import {} from '@routable/framework';
import {} from '../Table/table.types';
import {} from './components/columnselect/tablematic.columnselect.types';
import {} from 'react';
export const isFieldSizeInPixels = (fieldSize) => typeof fieldSize === 'string' && fieldSize.endsWith('px');
export const getHeaderOrBodyCellProps = (fieldSize) => isFieldSizeInPixels(fieldSize) ? { style: { width: fieldSize } } : { className: `w-tablematic-cell--${fieldSize}` };
